import React from "react";
import PropTypes from "prop-types";
import Collapse, { Panel } from "rc-collapse";

import FunctionalButton from "components/common/FunctionalButton";

import "rc-collapse/assets/index.css";


const FunctionalCollapse = ({ children, onClick, ButtonText, header, showButton = true }) => {
    let extra = null;
    if (showButton) {
        extra = (
            <FunctionalButton
                variant="secondary"
                value={ButtonText}
                onClick={onClick}
            />
        );
    }

    return (
        <Collapse defaultActiveKey="1">
            <Panel header={header} key="1" extra={extra}>
                {children}
            </Panel>
        </Collapse>
    );
};

FunctionalCollapse.propTypes = {
    ButtonText: PropTypes.string.isRequired,
    header: PropTypes.string.isRequired,
    children: PropTypes.node,
    onClick: PropTypes.func.isRequired,
    showButton: PropTypes.bool
};

export default FunctionalCollapse;
